<template>
    <div class="relative pr-3 py-3 opp-container" :style="statusStyle">
        <div class="oppTitle pr-4">
            <a :href="overviewUrl" class="black-link bold" target="_blank">
                {{ data.name }}
            </a>
        </div>
        <CompassIconButton icon="rightpanel" class="pipeline-card__panel" @click="openPanel()" />

        <ul class="oppDetails">
            <li class="mt-1">
                <span class="semibold">
                    {{ data.formatted_potential }}
                </span>
            </li>

            <!-- Third name -->
            <li v-if="data.formatted_thirdname.params" class="mt-2 bold">
                <person-list
                    :list="data.formatted_thirdname.params.list"
                    context="opportunity"
                    :related-data="{ type: 'opportunity', id: data.id }"
                />
            </li>

            <!-- main Contact -->
            <li v-if="data.formatted_thirdcontacts.params" class="mt-1 l">
                <person-list
                    :list="data.formatted_thirdcontacts.params.list"
                    context="opportunity"
                    :related-data="{ type: 'opportunity', id: data.id }"
                />
            </li>

            <!-- Task pin -->
            <li v-if="data.formatted_tasks" class="mt-2">
                <listing-dropdown
                    v-bind="data.formatted_tasks.params"
                    :step="data.step"
                    placeholder=""
                />
            </li>

            <!-- Event pin -->
            <li v-if="data.formatted_events" class="mt-2">
                <listing-dropdown v-bind="data.formatted_events.params" placeholder="" />
            </li>

            <!-- linked docs pin -->
            <li v-if="data.formatted_nbLinkedDocs" class="mt-2">
                <listing-dropdown v-bind="data.formatted_nbLinkedDocs.params" placeholder="" />
            </li>
        </ul>

        <ul v-if="showMore" class="oppMoreDetails mt-2">
            <!-- Scoring -->
            <a v-if="data.thirdscore" href="javascript:;" @click="score">
                <span class="score label label-nobackground label-border">
                    {{ data.formatted_thirdscore }}
                </span>
            </a>

            <!-- Due Date -->
            <li class="mt-2">
                <span class="gray-60">
                    {{ $l10n.__('Échéance') }}
                </span>
                :
                <span class="semibold">
                    {{ data.formatted_dueDate }}
                </span>
            </li>

            <!-- Creation Date -->
            <li class="mt-1">
                <span class="gray-60">
                    {{ $l10n.__('Création') }}
                </span>
                :
                <span class="semibold">
                    {{ data.formatted_created }}
                </span>
            </li>

            <!-- Oppo ID -->
            <li class="mt-2">
                <span class="gray-60">
                    {{ $l10n.__('ID') }}
                </span>
                :
                <span class="semibold" v-html="data.ident" />
            </li>

            <!-- Nb day in step -->
            <li v-if="data.nbDayInCurrentStep > 0" class="mt-2">
                <span class="gray-60">
                    {{ $l10n.__("Dans l'étape depuis") }}
                </span>
                :
                <span class="semibold">
                    {{ data.formatted_nbDayInCurrentStep }}
                </span>
            </li>

            <!-- COLLAB -->
            <li v-if="data.formatted_staffs && data.formatted_staffs.params" class="mt-2 prelative">
                <span class="gray-60">
                    {{ $l10n.__('Collaborateurs affectés') }}
                </span>
                <person-list :list="data.formatted_staffs.params.list" class="semibold" />
            </li>

            <!-- OWNER -->
            <li
                v-if="data.formatted_owner && data.formatted_owner.params"
                class="mt-2 prelative opp-owner"
            >
                <span class="gray-60">
                    {{ $l10n.__('Propriétaire') }}
                </span>
                <person-list :list="data.formatted_owner.params.list" class="semibold" />
            </li>
        </ul>

        <CompassIconButton
            :icon="showMore ? 'caret-up' : 'caret-down'"
            size="small"
            class="pipeline-card__show-more"
            @click="toggleShowMore"
        />
    </div>
</template>

<script>
import PersonList from 'vcomponents/utilities/PersonList.vue';
import ListingDropdown from './ListingDropdown.vue';
import { createNamespacedHelpers } from 'vuex';

import { allStatus } from 'Dictionaries/statusColors';

const { mapState } = createNamespacedHelpers('corp');
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    components: {
        'person-list': PersonList,
        ListingDropdown,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        tableDensity: {
            type: String,
        },
    },
    data() {
        return {
            showMore: this.tableDensity === 'condensed' ? false : true,
            rows: [],
        };
    },
    computed: {
        ...mapState({
            corpId: 'id',
        }),
        statusStyle() {
            const color = allStatus[this.data.status].color || allStatus['none'].color;
            return {
                borderLeft: `4px solid var(--colors-component-border-tag-${color})`,
            };
        },
        overviewUrl() {
            if (this.data.contextmenu.items.length > 0) {
                const item = this.data.contextmenu.items.find((item) => item.id === 'seeopp');
                return item !== undefined ? item.action : false;
            }
            return false;
        },
    },
    watch: {
        tableDensity(newVal) {
            this.showMore = newVal === 'condensed' ? false : true;
        },
    },
    methods: {
        ...popupPanelMapActions(['open']),
        score() {
            window.ScoringEvent.history(this.corpId, this.data.thirdid);
        },
        toggleShowMore() {
            this.showMore = !this.showMore;
        },
        goto(url, target) {
            window.open(url, target);
        },
        openPanel() {
            this.open({
                key: 'opportunityForm',
                props: {
                    oppId: this.data.id,
                    mode: 'read',
                    context: 'pipeline',
                    emitEditSuccess: 'listing:refresh',
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.pipeline-card {
    &__show-more {
        position: absolute;
        bottom: 16px;
        right: 16px;
        color: var(--colors-common-icon-neutral);
    }
    &__panel {
        position: absolute;
        top: 16px;
        right: 16px;
    }
}
</style>

<style lang="sass" scoped>
.opp {
    &-container {
        padding-left: 12px;
    }

    &-owner {
        margin-bottom: 20px;
    }
}
</style>
